import { Ub04Form } from '../../../services/ub04Service';
import { Cms1500Form } from '../../../services/cms1500Service';

/**
 * Check if a form has unsaved changes
 * @param form The form to check
 * @returns True if the form has unsaved changes
 */
export const hasUnsavedChanges = (form: Ub04Form | Cms1500Form | null): boolean => {
  if (!form) return false;
  return !!form.isDirty;
};

/**
 * Format a date to a human-readable string
 * @param date The date to format
 * @returns The formatted date string
 */
export const formatDate = (date: Date | null | undefined): string => {
  if (!date) return '';
  
  try {
    const d = new Date(date);
    if (isNaN(d.getTime())) return '';
    
    return d.toLocaleDateString();
  } catch (error) {
    console.error('Error formatting date:', error);
    return '';
  }
};

/**
 * Get a display name for a form
 * @param form The form to get a name for
 * @param index The index of the form
 * @returns A display name for the form
 */
export const getFormDisplayName = (
  form: Ub04Form | Cms1500Form | null, 
  index: number
): string => {
  if (!form) return `Form ${index + 1}`;
  
  // If the form has a patient name, use it
  if (form.patientName) {
    return `${form.patientName} (${index + 1})`;
  }
  
  return `Form ${index + 1}`;
};

/**
 * Check if a form is valid and can be saved
 * @param form The form to validate
 * @returns True if the form is valid
 */
export const isFormValid = (form: Ub04Form | Cms1500Form | null): boolean => {
  if (!form) return false;
  
  // Basic validation - check for required fields
  // This can be expanded based on specific form requirements
  if (!form.policyNumber || !form.patientName) {
    return false;
  }
  
  return true;
};
